import React, { useState, useEffect, useRef, useCallback } from 'react'
import { YandexMap } from '../yandex-map/YandexMap'
import './Pickup.scss'

const Pickup = ( {deliveryVariants}) => {
    const [searchAddress, setSearchAddress] = useState();   
    const [appliedSearchAddress, setAppliedSearchAddress] = useState('');    
    const [activePickupTab, setActivePickupTab] = useState(0);    
    const [selectedOnMapPoint, setSelectedOnMapPoint] = useState('');

    const [mobileView, setMobileView] = useState('map');
    const [mobileFiltersOpened, setMobileFiltersOpened] = useState(false);
    const [changeModeBtnText, setChangeModeBtnText] = useState("Показать списком");

    const balloonRef = useRef(null);
    
    const yandexMapRef = useRef(null),
          placemarks = useRef([]),
          map = useRef(),
          clusterer = useRef();

    let searchAddressTimeout = useRef();

    const tabsTitle = {
        0: "Показать все",
        1: "Только магазины 1С-Интерес",
        2: "Только пункты выдачи"
    }

    const [width, setWidth] = useState(window.innerWidth);

    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }); 

    const isMobile = width <= 1220;

    const checkShopsExistsInList = () => {
        if (!deliveryVariants || !deliveryVariants.POINTS || !deliveryVariants.POINTS.pickup || !deliveryVariants.POINTS.pickup.points) return false

        for (let item of deliveryVariants.POINTS.pickup.points) {
            if (!item) continue
            if (item.type !== 'shop') continue

            return true
        }

        return false
    }

    const getPickupItemsList = useCallback(() => {
        if (!deliveryVariants || !deliveryVariants.POINTS || !deliveryVariants.POINTS.pickup || !deliveryVariants.POINTS.pickup.points) return null
        
        const result = [];

        for (let item of deliveryVariants.POINTS.pickup.points) {
            if (!item) continue

            if(item.type === undefined || item.id === undefined)
                continue;

             if (activePickupTab > 0) {
                if (activePickupTab === 1 && item.type !== 'shop') {
                    continue
                } else if (activePickupTab === 2 && item.type === 'shop') {
                    continue
                }
            }

            if (appliedSearchAddress && appliedSearchAddress.length > 0 &&
                !item.address.toLowerCase().includes(appliedSearchAddress.toLowerCase())) {
                continue
            }

            result.push(item)
        }        

        return result;
    }, [deliveryVariants, appliedSearchAddress, activePickupTab]);

    const makePlacemarks = useCallback(() => {
        const ymaps = window.ymaps
        const geoObjects = new Map()

        geoObjects.set('point', [])

        const now = new Date()
        const dayOfWeek = now.getDay()

        const items = getPickupItemsList()

        for (let i = 0; i < items.length; i++) {
            const item = items[i]
            const type = 'point'

            const name = '<div class="yandex_balloon__name">' + item.name + '</div>'
            const floor = ''
            const phone = '<div class="yandex_balloon__phone">' + item.phone + '</div>'
            const metro = ''
            const address = '<div class="yandex_balloon__address">' + item.address + '</div>'
            const scheme = ''

            const days = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
            let dayList = ''

            for (let i = 0; i < 7; i++) {
                let active = ' '
                if (dayOfWeek === (i + 1)) {
                    active = ' class="active" '
                }

                dayList += (`<li${active} data-time="${item.workDays[i]}"> ${days[i]}</li>`)
            }

            const time = `<ul>${dayList}</ul>`

            const timeTxt = item.type === 'shop' ? "Время работы магазина:" : "Время работы пункта выдачи:";

            const balloon = '<div class="yandex_balloon">' +
                '<div class="yandex_balloon__info">' +
                '<div class="yandex_balloon__descr">' +
                name +
                floor +
                phone +
                metro +
                address +
                '</div>' +
                '<div class="yandex_balloon__dates">' +
                scheme +
                '<div class="yandex_balloon__time"><div>' + timeTxt + '</div>' +
                time +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>'

            let iconImageHref = '/images/mapIcon.png'
            let iconImageSize = [56, 37]
            let iconImageOffset = null
            if (item.pointType) {
                switch (item.pointType) {
                    case 'POSTAMAT':
                        iconImageHref = '/images/5post-p-min.png'
                        iconImageSize = [38, 55]
                        iconImageOffset = [-19, -55]
                        break
                    case 'TOBACCO':
                        iconImageHref = '/images/5post-t-min.png'
                        iconImageSize = [38, 55]
                        iconImageOffset = [-19, -55]
                        break
                    case 'ISSUE_POINT':
                        iconImageHref = '/images/5post-o-min.png'
                        iconImageSize = [39, 56]
                        iconImageOffset = [-19, -56]
                        break
                    default:
                        break
                }
            } else {
                switch (item.type) {
                    case 'cdek':
                        iconImageHref = '/images/cdek-min.png'
                        iconImageSize = [34, 57]
                        iconImageOffset = [-16, -57]
                        break
                    case 'boxberry':
                        iconImageHref = '/images/boxberry-min.png'
                        iconImageSize = [34, 57]
                        iconImageOffset = [-16, -57]
                        break
                    case 'pickpoint':
                        iconImageHref = '/images/picpoint-min.png'
                        iconImageSize = [34, 57]
                        iconImageOffset = [-16, -57]
                        break
                    case 'shiptor':
                        iconImageHref = '/images/shiptor.png'
                        iconImageSize = [34, 54]
                        iconImageOffset = [-17, -54]
                        break
                    default:
                        break
                }
            }

            var iconProperty = {
                preset: 'islands#orangeIcon',
                balloonPanelMaxMapArea: 0,
                iconLayout: 'default#image',
                iconImageHref: iconImageHref,
                iconImageSize: iconImageSize
            }

            if (iconImageOffset != null) {
                iconProperty.iconImageOffset = iconImageOffset
            }

            const placemark = new ymaps.Placemark([item.yandexCoordsLa, item.yandexCoordsLo], {
                balloonContentBody: balloon,
                hintContent: item.name
            }, iconProperty)

            placemark.events.add('click', function () {
                setSelectedOnMapPoint(`${item.type}-${item.id}`);

                const row = document.getElementById(item.type + '-' + item.id)
                if (row) {
                    row.scrollIntoView()
                }
            })

            geoObjects.get(type).push(placemark)
            placemarks.current[item.type + '-' + item.id] = placemark
        }

        return geoObjects;

    }, [getPickupItemsList]);

    const paintYandexMap = useCallback(() => {
        const ymaps = window.ymaps
        map.current = new ymaps.Map(yandexMapRef.current, {
            center: [55.751574, 37.573856],
            zoom: 9
        }, {
            searchControlProvider: 'yandex#map'
        })

        clusterer.current = new ymaps.Clusterer({
            preset: 'islands#invertedOrangeClusterIcons',
            groupByCoordinates: false,
            clusterDisableClickZoom: false,
            maxZoom: 14,
            clusterHideIconOnBalloonOpen: false,
            geoObjectHideIconOnBalloonOpen: false
        })

        const geoObjects = makePlacemarks()

        geoObjects.forEach(function (value) {
            clusterer.current.add(value)
        })

        map.current.geoObjects.add(clusterer.current)

        map.current.setBounds(clusterer.current.getBounds(), {
            checkZoomRange: true
        })
    }, [makePlacemarks]);

    const repaintYandexMap = useCallback(() => {
        if (!clusterer.current || !map.current) return

        clusterer.current.removeAll()
        map.current.geoObjects.removeAll()

        const geoObjects = makePlacemarks()

        geoObjects.forEach(function (value) {
            clusterer.current.add(value)
        })

        map.current.geoObjects.add(clusterer.current)

        const bounds = clusterer.current.getBounds()

        if (bounds) {
            map.current.setBounds(bounds, {
                checkZoomRange: true
            })
        }
    }, [makePlacemarks]);

    const isCluster = (placemark, n) => {
        const state = clusterer.current.getObjectState(placemark)

        map.current.setCenter(placemark.geometry.getCoordinates())
        map.current.setZoom(n)

        if (state.isClustered === false) {
            return true
        } else {
            isCluster(placemark, n + 1)
            return false
        }
    }

    const openBalloon = (item) => {
        if (!map.current || !clusterer.current) return

        const key = item.type + '-' + item.id
        if (!placemarks.current[key]) {
            return
        }

        setSelectedOnMapPoint(key);

        const placemark = placemarks.current[key]
        let state = clusterer.current.getObjectState(placemark)

        if (!state.isShown) {
            map.current.setCenter(placemark.geometry.getCoordinates())
            map.current.setZoom(5)
            state = clusterer.current.getObjectState(placemark)
        }

        if (state.isClustered && state.cluster) {
            if (isCluster(placemark, 10) === false) {
                placemark.balloon.open();
                balloonRef.current = (mobileView === 'list') ? balloonRef.current = placemark : null;
            }
        } else {
            placemark.balloon.open();
            balloonRef.current = (mobileView === 'list') ? balloonRef.current = placemark : null;
        }
    }
    
    const onSearchAddressChange = (e) => {
        setSearchAddress(e.target.value);
    }

    useEffect(() => {
        repaintYandexMap()
    }, [appliedSearchAddress, activePickupTab, repaintYandexMap])

    const searchAddressApply = useCallback(() => {
        if (!searchAddress || searchAddress.length === 0) {
            setAppliedSearchAddress('')
        } else {
            setAppliedSearchAddress(searchAddress)
        }
    }, [searchAddress]);

    useEffect(() => {
        if (searchAddressTimeout.current !== null) {
            clearTimeout(searchAddressTimeout.current)
            searchAddressTimeout.current = null
        }

        searchAddressTimeout.current = setTimeout(() => {
            searchAddressApply()
            searchAddressTimeout.current = null
        }, 500)

    }, [searchAddress, searchAddressApply])

    const selectTab = (val) => {
        setActivePickupTab(val);
        setMobileFiltersOpened(false);
    }

    const toggleMode = () => {
        setMobileView(state => {
            return (state === 'map') ? 'list' : 'map'
        })        

        setChangeModeBtnText(state => (state === "Показать на карте") ? "Показать списком" : "Показать на карте");
    }

    useEffect(() => {
        if(balloonRef.current !== null) {
            balloonRef.current.balloon.open();
            balloonRef.current = null;
        }
    }, [mobileView]);

    let addressList = [];
    let pickupItemsList = getPickupItemsList();

    for (let item of pickupItemsList) {
        if(item.type === undefined || item.id === undefined)
            continue;
        const itemFullId = `${item.type}-${item.id}`;
        let elemClass = 'order__pickup_address__item';
        elemClass += selectedOnMapPoint === itemFullId ? ' active' : '';

        let itemTypeTitle = '';

        if (item.type === 'shop' && item.id === '16852836')
            itemTypeTitle = "Пункт выдачи в центральном офисе 1С Интерес";
        else if (item.type === 'shop')
            itemTypeTitle = "Магазин сети 1С Интерес";
        else if (item.type === 'cdek')
            itemTypeTitle = "Пункт выдачи CDEK";
        else if (item.type === 'pickpoint')
            itemTypeTitle = "Пункт выдачи PickPoint";
        else if (item.type === 'boxberry')
            itemTypeTitle = "Пункт выдачи Boxberry";
        else if (item.type === 'shiptor')
            itemTypeTitle = "Пункт выдачи Сбербанк";
        else if (item.type === '5post') 
            itemTypeTitle = "Пункт выдачи 5Post";

        const elem = <div
            id={itemFullId}
            key={itemFullId}
            className={elemClass}
            onClick={() => openBalloon(item)}>

            <strong>{itemTypeTitle} {item.address}</strong><br/>
            Тел: {item.phone}<br/>
        </div>

        addressList.push(elem)
    }

    let addressListClasses = 'order__pickup_address__list',
        mapBlockClasses = 'order__pickup_choose'

    if (isMobile && mobileView === 'list') {
        addressListClasses = 'order__pickup_address__list'
        mapBlockClasses = 'order__pickup_choose d-none'
    } else if (isMobile && mobileView === 'map') {
        addressListClasses = 'order__pickup_address__list d-none'
        mapBlockClasses = 'order__pickup_choose'
    }

    return (             
        <>        
        <div className="order__pickup_wrap">
            <div className="order__pickup_address">
                <div className="order__pickup_address__search">
                    <input type="text" className="order__pickup_address__input" value={searchAddress} onChange={onSearchAddressChange} placeholder="Поиск по адресу" />
                    <span className="order__pickup_address__input_icon"></span> 
                </div>

                <div className={addressListClasses}>
                    {addressList}
                </div>
            </div>

            <div className={mapBlockClasses}>
                {checkShopsExistsInList() &&
                <div className={mobileFiltersOpened ? 'order__pickup_tabs showed' : 'order__pickup_tabs'}>
                    <div className="order__pickup_tabs__title">
                        Фильтр:&nbsp;
                        <span className='order__pickup_tabs__filter' 
                            onClick={() => setMobileFiltersOpened(state => !state)}>
                            {tabsTitle[activePickupTab]}
                        </span>
                    </div>
                    <div className="order__pickup_tabs__list">
                        <div 
                            className={activePickupTab === 0 ? 'order__pickup_tab active' : 'order__pickup_tab'}
                            onClick={() => selectTab(0)}>
                            <span>{tabsTitle[0]}</span>
                        </div>

                        <div className="order__pickup_tab__wrap">
                            <div
                                className={activePickupTab === 1 ? 'order__pickup_tab active' : 'order__pickup_tab'}
                                onClick={() => selectTab(1)}>
                                <span>{tabsTitle[1]}</span>
                                <div className="order__pickup_tab__additional">"Доставим бесплатно"</div>
                            </div>
                        </div>

                        <div
                            className={activePickupTab === 2 ? 'order__pickup_tab active' : 'order__pickup_tab'}
                            onClick={() => selectTab(2)}>
                            <span>{tabsTitle[2]}</span>
                        </div>
                    </div>
                </div>
                }

                <YandexMap yandexMapRef={yandexMapRef}
                           initCallback={paintYandexMap}
                           mapExists={!!map.current}/>
            </div>
            <div className="order__pickup_change">
                <button className="btn btn_outline_orange order__pickup_change__btn"
                        type="button" onClick={toggleMode}>
                    {changeModeBtnText}
                </button>
            </div>
        </div> 
        </>
    )
}

export {Pickup}